import {
  Avatar,
  Box,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Dropdown from "../../reusable_components/components/Dropdown";
import "./jobpostings.css";
import {
  useAssignRecruiterMutation,
  useGetClientDropdownQuery,
  useGetCoordinatorDropdownQuery,
  useGetJobPostingsTableDatasMutation,
  useJobAssignedListMutation,
  useRecruiterListMutation,
  useRecruitersCommissionSaveMutation,
  useSaveDuplicateMutation,
  useSelectRecruiterListMutation,
} from "../../redux/jobpostings/jobpostings.api";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MUIButton from "../../reusable_components/components/MUIButton";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { useSelector } from "react-redux";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DoneIcon from "@mui/icons-material/Done";
import DownloadIcon from "../../assets/Icons/DownloadIcon";
import SearchIconLg from "../../assets/Icons/SearchIcon";
import EditIcon from "../../assets/Icons/EditIcon";
import UserPlusIcon from "../../assets/Icons/AssignCandidateIcon";
import UsersIcon from "../../assets/Icons/CandidatesIcon";
import FileManageEventsIcon from "../../assets/Icons/ManageEventsIcon";
import CopyIcon from "../../assets/Icons/CopyIcon";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import { TabContext, TabList } from "@mui/lab";
import { useGetPositionLevelDropDownQuery } from "../../redux/Signup/signup.api";
import Duplicate from "../../assets/duplicate.png"

const JobPosting = () => {
  const commonFilter = JSON.parse(localStorage.getItem("commonsearchfilter"));
  const [selectedPositionType, setSelectedPositionType] = useState(
    commonFilter?.JobPosting?.positionType || ""
  );
  const [positionId, setPositionId] = useState(
    commonFilter?.JobPosting?.positionId || ""
  );
  const [selectedClient, setSelectedClient] = useState(
    commonFilter?.JobPosting?.clientName || ""
  );
  const [selectedStatus, setSelectedStatus] = useState(
    commonFilter?.JobPosting?.status || ""
  );
  const [selectedPriority, setSelectedPriority] = useState(
    commonFilter?.JobPosting?.priority || ""
  );
  const [positionDesc, setPositionDesc] = useState(
    commonFilter?.JobPosting?.positionDesc || ""
  );
  const [selectedClientName, setSelectedClientName] = useState(
    commonFilter?.JobPosting?.selectedClientName || ""
  );
  const [dashBoardDisabled, setDashBoardDisabled] = useState(false);

  const [selectedlevelIds, setSelectedlevelIds] = useState([]);
  const [selectedLevelNames, setSelectedLevelNames] = useState([]);

  const [chips, setChips] = useState([]);
  const [open, setOpen] = useState(false);
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [dialogId, setDialogId] = useState("");
  const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);
  const [dupPositionId, setDupPositionId] = useState("");
  const [rowDatas, setRowDatas] = useState({});
  const { Profile } = useSelector((state) => state.common);
  const { Snackbar } = useContext(SnackbarContext);
  const [showClearFilter, setShowClearFilter] = useState(false);
  const userRole = Profile?.profile?.role;
  const externalRecruiter = Profile?.profile?.isExternalRecruiter;
  const [downloadProgress, setDownloadProgress] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [openPosition, setOpenPosition] = useState(false);
  const [openByStatus, setOpenByStatus] = useState(false);
  const [openByPriority, setOpenByPriority] = useState(false);
  const [openClientName, setOpenClientName] = useState(false);

  const getRandomColor = () => {
    const colors = [
      "green",
      "darkorange",
      "purple",
      "#5e09e7",
      "orangered",
      "darkgreen",
      "blue",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const handleOpen = (item) => {
    setOpen(true);
    setDialogId(item?.positionId);
    setRowDatas(item);
  };

  const handleClose = () => {
    setOpen(false);
    setRecruiterCheckbox([]);
    setIsAssign([]);
    setSearchRecruiter("");
    setValue("2");
  };

  const handleFilterDialogOpen = () => {
    if (chips.length === 0) {
      setPositionId(commonFilter?.JobPosting?.positionId || "");
      setSelectedClientName(commonFilter?.JobPosting?.selectedClientName || "");
      setSelectedClient(commonFilter?.JobPosting?.clientName || "");
      setSelectedPositionType(commonFilter?.JobPosting?.positionType || "");
      setSelectedPriority(commonFilter?.JobPosting?.priority || "");
      setSelectedStatus(commonFilter?.JobPosting?.status || commonFilter?.jobPosting?.status);
      setSelectedLevelNames([]);
      setFilterDialogOpen(true);
    } else {
      setPositionId(commonFilter?.JobPosting?.positionId || "");
      setSelectedClientName(commonFilter?.JobPosting?.selectedClientName || "");
      setSelectedClient(commonFilter?.JobPosting?.clientName || "");
      setSelectedPositionType(commonFilter?.JobPosting?.positionType || "");
      setSelectedPriority(commonFilter?.JobPosting?.priority || "");
      setSelectedStatus(commonFilter?.JobPosting?.status || commonFilter?.jobPosting?.status);
      setSelectedLevelNames([]);
      setFilterDialogOpen(true);
    }
  };

  const handleFilterDialogClose = () => {
    const isLable = chips?.some((item) => item?.label);

    if (!isLable) {
      setFilterDialogOpen(false);
      setPositionId("");
      setSelectedClientName("");
      setSelectedClient("");
      setSelectedPositionType("");
      setSelectedPriority("");
      setSelectedStatus("");
      setSelectedLevelNames([]);
      setSelectedlevelIds([]);
      localStorage.setItem(
        "commonsearchfilter",
        JSON.stringify({
          ...commonFilter,
          JobPosting: {},
        })
      );
    } else {
      setFilterDialogOpen(false);
    }
  };

  const handleDuplicateDialogOpen = (item) => {
    setDuplicateDialogOpen(true);
    setDupPositionId(item?.positionId);
  };

  const handleDuplicateDialogClose = () => {
    setDuplicateDialogOpen(false);
  };

  const [keywords, setKeywords] = useState("");
  const [clientDropdownDatas, setClientDropdownDatas] = useState([]);
  const [location, setLocation] = useState("");
  const [coordinatorDropdownDatas, setCoordinatorDropdownDatas] = useState([]);
  const [selectedCoordinator, setSelectedCoordinator] = useState("");
  const [jobPostingTableDatas, setJobPostingTableDatas] = useState([]);
  const [recruitersNames, setRecruiterNames] = useState([]);
  const [recruiterCheckbox, setRecruiterCheckbox] = useState([]);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [selectedCoordinatorName, setSelectedCoordinatorName] = useState("");
  const [searchRecruiter, setSearchRecruiter] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [triggerApi, setTriggerApi] = useState(false);
  const [tabValue, setTabValue] = useState(localStorage.getItem("TabId") ? localStorage.getItem("TabId") : "0");
  // Pagination
  const [page, setPage] = useState(+localStorage.getItem("newPage") || 1);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const navigate = useNavigate();

  const [getTableDatas] = useJobAssignedListMutation();
  const { data: getClientDropdown, refetch } = useGetClientDropdownQuery();
  const { data: getCoordinatordropdown } = useGetCoordinatorDropdownQuery();
  const { data: positionLevelDropDown } = useGetPositionLevelDropDownQuery();
  const [recruiterList] = useRecruiterListMutation();
  const [selectRecruiterList, { isLoading: recruiterListLoader }] =
    useSelectRecruiterListMutation();
  const [assignRecruiter] = useAssignRecruiterMutation();
  const [saveDuplicate, { data: duplicateRow }] = useSaveDuplicateMutation();
  // const [downloadExcelFile] = useDownloadExcelFileMutation()

  // Dropdown Api's
  useEffect(() => {
    refetch();
    if (getClientDropdown) {
      setClientDropdownDatas(getClientDropdown?.response?.clientList);
    }

    if (getCoordinatordropdown) {
      setCoordinatorDropdownDatas(
        getCoordinatordropdown?.response?.coordinatorList
      );
    }
  }, [getClientDropdown, getCoordinatordropdown]);

  const [searchClient, setSearchClient] = useState("")
  const handleSearchClient = (e) => {
    setSearchClient(e.target.value)
  }
  const filterClient = clientDropdownDatas?.filter((name) =>
    name?.clientName?.toLowerCase().startsWith(searchClient?.toLowerCase())
  )
  // Table Datas api
  const getGridDatas = async (id) => {
    localStorage.setItem("TabId", id);
    try {
      const posId = /^\d*$/.test(positionId);
      const loginId =
        Profile?.profile?.role === "recruiter" ||
          Profile?.profile?.role === "coordinator"
          ? Profile?.profile?.emailId
          : undefined;

      const payload = {
        positionDesc: positionDesc || "",
        clientName: selectedClient ? +selectedClient : null,
        // coordinator: selectedCoordinator ? selectedCoordinator : 0,
        // keywords: searchKeyword ? searchKeyword : keywords,
        // location: location ? location : "",
        page: page - 1,
        positionId: posId ? +positionId : 0,
        positionType: selectedPositionType ? selectedPositionType : null,
        priority: selectedPriority ? selectedPriority : null,
        size: rowsPerPage ? rowsPerPage : 10,
        status: selectedStatus ? selectedStatus : null,
        displayName: null,
        workCategory: id === "0" ? "IT" : "Non-IT",
        jobPositionLevelIds: selectedlevelIds || [],
        // loginId: loginId
      };

      setShowTableLoader(true);
      const response = await getTableDatas(payload).unwrap();
      setShowTableLoader(false);
      if (response) {
        const datas = response?.response ? response?.response?.data : [];
        setJobPostingTableDatas(datas);
        setTotalDataCount(response?.response?.totalCount);
      }
    } catch (err) {
      Snackbar("Network Error", "error");
      setShowTableLoader(false);
    }
  };

  useEffect(() => {
    getGridDatas(localStorage.getItem("TabId") || "0");
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (positionDesc) {
      // getGridDatas(localStorage.getItem("TabId") || "0");
      // setPage(1);
    }
  }, [positionDesc]);

  useEffect(() => {
    if (triggerApi) {
      getGridDatas(localStorage.getItem("TabId") || "0");
      setFilterDialogOpen(false);
      setTriggerApi(false);
    }
  }, [
    getTableDatas,
    selectedClient,
    selectedCoordinator,
    keywords,
    location,
    positionId,
    selectedPositionType,
    selectedPriority,
    selectedStatus,
    rowsPerPage,
    page,
    duplicateRow,
    triggerApi,
    searchKeyword,
    positionDesc,
  ]);

  useEffect(() => {
    const getRecruitersDialog = async () => {
      try {
        const payload = {
          positionId: dialogId,
        };

        if (open) {
          const response = await selectRecruiterList(payload).unwrap();
          setRecruiterNames((response && response?.response) || []);
          setRecruiterCheckbox(
            response?.response
              ?.filter((item) => item?.hasSelected)
              ?.map((item) => item?.recruiterId)
          );
        } else {
          setRecruiterNames([]);
        }
      } catch (err) {
        // alert('Network error')
      }
    };
    getRecruitersDialog();
  }, [open]);

  const [value, setValue] = useState("2");

  const handleChange = (value) => {
    setValue(value);
  };

  const assignedRecruiters = recruitersNames?.filter(
    (item) => item?.hasSelected === true
  );
  const UnassignRecruiters = recruitersNames?.filter(
    (item) => item?.hasSelected === false
  );

  const filteredRecruiterLists =
    value === "1"
      ? assignedRecruiters?.filter((name) => {
        return name?.recruiterName
          ?.toLowerCase()
          ?.startsWith(searchRecruiter?.toLowerCase());
      })
      : UnassignRecruiters?.filter((item) => {
        return item?.recruiterName
          ?.toLowerCase()
          ?.startsWith(searchRecruiter?.toLowerCase());
      });

  const handleSearchRecruiterChange = (e) => {
    const value = e.target.value;
    setSearchRecruiter(value);
  };

  const [isAssign, setIsAssign] = useState([]);

  const handleAssignRecruiterCheckbox = (recruiterId) => {
    setRecruiterCheckbox((prev) =>
      prev?.includes(recruiterId)
        ? prev?.filter((id) => id !== recruiterId)
        : [...prev, recruiterId]
    );

    setIsAssign((prev) =>
      prev?.includes(recruiterId)
        ? prev?.filter((id) => id !== recruiterId)
        : [...prev, recruiterId]
    );
  };

  const handleAssignRecruiter = async () => {
    if (isAssign?.length === 0) {
      return;
    } else {
      try {
        const payload = {
          // PositionId: 17,
          PositionId: dialogId,
          recruiter: recruiterCheckbox,
          recruiterREE: recruiterCheckbox,
        };

        const response = await assignRecruiter(payload).unwrap();
        if (response?.status === 200) {
          if (value === "1") {
            Snackbar(
              "The job posting has been unassigned successfully",
              "success"
            );
          } else {
            Snackbar(
              "The job posting has been assigned successfully",
              "success"
            );
          }
          setRecruiterCheckbox([]);
          setIsAssign([]);
          handleClose();
        }
      } catch (err) {
        Snackbar("Network error", "error");
      }
    }
  };

  useEffect(() => {
    const getRecruiterList = async () => {
      try {
        const payload = {
          keyWords: "",
          page: 0,
          size: 10,
          type: "",
        };

        await recruiterList(payload).unwrap();
      } catch (err) {
        Snackbar("Network error", "error");
      }
    };
    getRecruiterList();
  }, [recruiterList]);

  const handlePositionIdChange = (e) => {
    const value = e.target.value;
    setPositionId(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      JobPosting: {
        ...currentFilter.JobPosting,
        positionId: value,
      },
    };
    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handlePositionTypeChange = (e) => {
    const value = e.target.value;
    setSelectedPositionType(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    // 2. Update the clientId inside dashbord
    const updatedFilter = {
      ...currentFilter,
      JobPosting: {
        ...currentFilter.JobPosting,
        positionType: value,
      },
    };

    // 3. Store the updated object back in localStorage
    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  // const handleKeywordChange = (e) => {
  //     const value = e.target.value
  //     setKeywords(value)
  // }

  const handleClientDropdownChange = (value) => {
    if (!value) {
      // When cleared
      setSelectedClient("");
      setSelectedClientName("");

      const currentFilter =
        JSON.parse(localStorage.getItem("commonsearchfilter")) || {};
      const updatedFilter = {
        ...currentFilter,
        JobPosting: {
          ...currentFilter.JobPosting,
          clientName: "",
          selectedClientName: "",
        },
      };
      localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
      return;
    }

    const data = value.toString();
    setSelectedClient(data);

    const name = getClientDropdown?.response?.clientList?.find(
      (id) => id?.clientId === +value
    );
    setSelectedClientName(name?.clientName || "");

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};
    const updatedFilter = {
      ...currentFilter,
      JobPosting: {
        ...currentFilter.JobPosting,
        clientName: +data,
        selectedClientName: name?.clientName || "",
      },
    };
    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handlePriorityChange = (e) => {
    const value = e.target.value;
    setSelectedPriority(value);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      JobPosting: {
        ...currentFilter.JobPosting,
        priority: value,
      },
    };
    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setLocation(value);
  };

  const handleCoordinatorchange = (value) => {
    setSelectedCoordinator(value);

    const name = getCoordinatordropdown?.response?.coordinatorList?.find(
      (id) => id?.coordinatorId === value
    );
    setSelectedCoordinatorName(name?.coordinatorName);
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setSelectedStatus(value || "Active");

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      JobPosting: {
        ...currentFilter.JobPosting,
        status: value || "Active",
      },
    };
    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleEditScreenNav = (item) => {
    if (
      Profile?.profile?.role === "admin" ||
      Profile?.profile?.role === "coordinator"
    ) {
      const id = item?.positionId;
      navigate(`/jobpostedit/${id}`, {
        state: { referrals: item?.isReferral },
      });
    }
  };

  // Pagination Functionalities
  const handleChangePage = (e, newPage) => {
    localStorage.setItem("newPage", newPage);
    setPage(newPage);
    setTriggerApi(true);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleSearchKeywordChange = (e) => {
    const value = e.target.value;
    // localStorage.setItem("jobSearchValue", value)
    setPositionDesc(value);
    setPage(1);
    setTriggerApi(true);

    const currentFilter =
      JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

    const updatedFilter = {
      ...currentFilter,
      JobPosting: {
        ...currentFilter.positionDesc,
        positionDesc: value,
      },
    };
    localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
  };

  const handleDownloadExcel = async () => {
    try {
      setDownloadProgress(0); // start at 0%

      const payload = {
        page: page - 1,
        size: 10,
        client: selectedClient || 0,
        coordinator: selectedCoordinator || 0,
        keywords: positionDesc || "",
        location: location || "",
        positionId: +positionId || 0,
        positionType: selectedPositionType || "",
        priority: selectedPriority || "",
        status: selectedStatus || "",
        workCategoryId: tabValue === "0" ? 1 : 2,
        jobPositionLevelIds: selectedlevelIds || [],
      };
      setDashBoardDisabled(true);
      const response = await fetch(
        window.REACT_APP_BASE_URL + `downloadExcelFile`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        }
      );
      setDashBoardDisabled(false);

      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        const json = await response.json();
        if (json?.data?.error_code === "70" || json?.data?.error_code === 70) {
          Snackbar(
            "The file cannot be downloaded as no data is available.",
            "error"
          );
          return;
        } else {
          Snackbar(json?.data?.error_message || "Unknown error", "error");
          return;
        }
      }

      if (!response.ok) throw new Error("Network response was not ok");

      const contentLength = response.headers.get("Content-Length");
      const total = contentLength ? parseInt(contentLength, 10) : null;

      const reader = response.body.getReader();
      const chunks = [];
      let receivedLength = 0;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        receivedLength += value.length;

        if (total) {
          const progress = Math.round((receivedLength / total) * 100);
          setDownloadProgress(progress);
        } else {
          setDownloadProgress((prev) => Math.min((prev || 0) + 3, 95));
        }
      }

      const blob = new Blob(chunks, {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Job Posting Details.xlsx");
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      setDownloadProgress(100); // set to 100% after download starts
    } catch (err) {
      Snackbar("Network Error", "error");
    } finally {
      setTimeout(() => setDownloadProgress(null), 1000);
    }
  };

  const handleProfileNav = (item) => {
    localStorage.removeItem("addProfileSearch");
    navigate(`/findprofile/${item?.positionId}`, {
      state: {
        positionId: item?.positionId,
        clientName: item?.clientName,
        positionTitle: item?.positionTitle,
        candidateTable: true,
      },
    });
  };

  const handleManageEventsNav = (item) => {
    navigate(`/manage-events/${item?.positionId}`, {
      state: {
        positionId: item?.positionId,
        clientName: item?.clientName,
        positionTitle: item?.positionTitle,
        positionStatus: item?.positionStatus,
      },
    });
  };

  const handleProfileSubmissionNav = (item) => {
    navigate(`/submitprofiles/${item?.positionId}`, {
      state: {
        position: item?.positionTitle,
        name: item?.clientName,
        isEdit: true,
        isReferral: item?.isReferral,
      },
    });
  };

  const handleDuplicate = async () => {
    try {
      const payload = {
        positionId: dupPositionId,
      };

      const response = await saveDuplicate(payload).unwrap();
      if (response?.status === 200) {
        Snackbar("Data Added Sucessfully", "success");
        handleDuplicateDialogClose();
        setTriggerApi(true);
      }
    } catch (err) {
      Snackbar("Network error", "error");
    }
  };

  const letsFilterDatas = () => {

    const updateChip = [
      {
        label: keywords,
        onDelete: () => {
          setKeywords("");
          setTriggerApi(true);
          setChips((prevChip) =>
            prevChip.filter((chips) => chips.label !== keywords)
          );
        },
      },
      {
        label: positionId,
        onDelete: () => {
          setPositionId("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              JobPosting: {
                ...commonFilter.JobPosting,
                positionId: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChip) =>
            prevChip.filter((chips) => chips.label !== positionId)
          );
        },
      },
      {
        label: selectedClientName,
        onDelete: () => {
          setSelectedClientName("");
          setSelectedClient("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              JobPosting: {
                ...commonFilter.JobPosting,
                selectedClientName: "",
                clientName: "",
              },
            })
          );
          setSearchClient("")
          setTriggerApi(true);
          setChips((prevChip) =>
            prevChip.filter((chips) => chips.label !== selectedClientName)
          );
        },
      },
      // When creating chips, keep both name + id
      ...selectedLevelNames.map((name, index) => {
        const id = selectedlevelIds[index]; // match ID for this name
        return {
          label: name,
          onDelete: () => {
            // ✅ Update IDs correctly (no stale state)
            setSelectedlevelIds((prevIds) => {
              const updatedIds = prevIds.filter((item) => item !== id);
              return updatedIds;
            });

            // ✅ Update Names correctly
            setSelectedLevelNames((prevNames) => {
              const updatedNames = prevNames.filter((n) => n !== name);
              return updatedNames;
            });

            // ✅ Remove chip
            setChips((prevChip) =>
              prevChip.filter((chip) => chip.label !== name)
            );

            setTriggerApi(true);
          },
        };
      }),

      {
        label: selectedPositionType,
        onDelete: () => {
          setSelectedPositionType("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              JobPosting: {
                ...commonFilter.JobPosting,
                positionType: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChip) =>
            prevChip.filter((chips) => chips.label !== selectedPositionType)
          );
        },
      },
      {
        label: selectedPriority,
        onDelete: () => {
          setSelectedPriority("");
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              JobPosting: {
                ...commonFilter.JobPosting,
                priority: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChip) =>
            prevChip.filter((chips) => chips.label !== selectedPriority)
          );
        },
      },
      {
        label: selectedCoordinatorName,
        onDelete: () => {
          setSelectedCoordinatorName("");
          setSelectedCoordinator("");
          setTriggerApi(true);
          setChips((prevChip) =>
            prevChip.filter((chips) => chips.label !== selectedCoordinatorName)
          );
        },
      },
      {
        label: selectedStatus,
        onDelete: () => {
          setSelectedStatus("");
          localStorage.setItem("defaultStatusRemoved", "true")
          localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({
              ...commonFilter,
              JobPosting: {
                ...commonFilter.JobPosting,
                status: "",
              },
            })
          );
          setTriggerApi(true);
          setChips((prevChip) =>
            prevChip.filter((chips) => chips.label !== selectedStatus)
          );
        },
      },
      {
        label: location,
        onDelete: () => {
          setLocation("");
          setTriggerApi(true);
          setChips((prevChip) =>
            prevChip.filter((chips) => chips.label !== location)
          );
        },
      },
    ];

    setChips(updateChip);
    setShowClearFilter(true);
    setTriggerApi(true);
  };

  useEffect(() => {
    const removedDefaultStatus = localStorage.getItem("defaultStatusRemoved");
    if (removedDefaultStatus !== "true") {
      const currentFilter = JSON.parse(localStorage.getItem("commonsearchfilter")) || {};
      const updatedFilter = {
        ...currentFilter,
        JobPosting: {
          ...currentFilter.JobPosting,
          status: "Active",
        },
      };
      localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
      setSelectedStatus("Active");
      setShouldFetch(true);
    } else {
      const stored = JSON.parse(localStorage.getItem("commonsearchfilter")) || {};
      const jobPosting = stored?.JobPosting;

      const hasValue =
        jobPosting &&
        Object.values(jobPosting).some(
          (value) =>
            value !== "" && value !== 0 && value !== null && value !== undefined
        );
      setShouldFetch(!!hasValue);
      setSelectedStatus(jobPosting?.status || "");
    }
  }, []);

  useEffect(() => {
    if (chips?.every((name) => !name?.label)) {
      setShowClearFilter(false);
    }
  }, [triggerApi]);

  const handleMoreFiltersDelete = () => {
    setPositionId("");
    setSelectedClientName("");
    setSelectedClient("");
    setSelectedPositionType("");
    setSelectedPriority("");
    setSelectedCoordinatorName("");
    setSelectedCoordinator("");
    setSelectedStatus("");
    setKeywords("");
    setLocation("");
    setSelectedlevelIds([]);
    setSelectedLevelNames([]);
    setTriggerApi(true);
    setShowClearFilter(false);
    localStorage.setItem(
      "commonsearchfilter",
      JSON.stringify({ ...commonFilter, JobPosting: {}, jobPosting: {} })
    );
    localStorage.setItem("defaultStatusRemoved", "true")
  };

  // const filteredTableDatas = jobPostingTableDatas?.filter((item) => {
  //     return (
  //         (item?.clientName?.trim()?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase())) ||
  //         (item?.positionTitle?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase()))
  //     )
  // })

  const priorityOptions = [
    {
      id: "High",
      label: "High",
    },
    {
      id: "Medium",
      label: "Medium",
    },
    {
      id: "Low",
      label: "Low",
    },
  ];

  const positionTypeOptions = [
    {
      id: "Permanent",
      label: "Permanent",
    },
    {
      id: "Contract",
      label: "Contract",
    },
    {
      id: "Contract-to-Hire",
      label: "Contract-to-Hire",
    },
    {
      id: "Gig Worker",
      label: "Gig Worker",
    },
  ];

  const statusOptions = [
    {
      id: "Active",
      label: "Active",
    },
    {
      id: "Inactive",
      label: "Inactive",
    },
    {
      id: "Fulfilled",
      label: "Fulfilled",
    },
    {
      id: "Closed",
      label: "Closed",
    },
    {
      id: "Hold by client",
      label: "Hold by client",
    },
    {
      id: "Dropped by 3E",
      label: "Dropped by 3E",
    },
    {
      id: "Pending",
      label: "Pending",
    },
  ];

  useEffect(() => {
    if (shouldFetch) {
      letsFilterDatas();
      setShouldFetch(false);
    }
  }, [page, shouldFetch]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    localStorage.setItem("TabId", newValue);
    getGridDatas(newValue);
    setPage(1);
    setPositionId("");
    setSelectedClientName("");
    setSelectedClient("");
    setSelectedPositionType("");
    setSelectedPriority("");
    setSelectedCoordinatorName("");
    setSelectedCoordinator("");
    setSelectedStatus("");
    setKeywords("");
    setLocation("");
    setSelectedlevelIds([]);
    setSelectedLevelNames([]);
    setTriggerApi(true);
    setShowClearFilter(false);
    localStorage.removeItem("commonsearchfilter");
  };

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };


  return (
    <Box className="container">
      <Grid2
        item
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <Typography className="title">
          {userRole === "recruiter" ? "Jobs Assigned" : "Job Postings"}
        </Typography>
        <div style={{ display: "flex", gap: "20px" }}>
          <Box>
            <TextField
              value={positionDesc}
              onChange={handleSearchKeywordChange}
              className="textfields"
              placeholder="Search By Position"
              slotProps={{
                input: {
                  startAdornment: (
                    <SearchIconLg style={{ paddingRight: "5px" }} />
                  ),
                },
              }}
            />
          </Box>
          {jobPostingTableDatas?.length > 0 && (
            <Tooltip
              title={dashBoardDisabled === true && "Please Wait..."}
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "black",
                    color: "white",
                    "& .MuiTooltip-arrow": {
                      color: "black",
                    },
                  },
                },
              }}
              arrow
            >
              <MUIButton
                title={
                  downloadProgress !== null
                    ? `Downloading... ${downloadProgress}%`
                    : "Download"
                }
                disabled={dashBoardDisabled}
                onClick={handleDownloadExcel}
                startIcon={<DownloadIcon stroke={"white"} />}
                sx={{
                  color: "white",
                  border: "1px solid #D6BBFB",
                  width: "200px",
                }}
              />
            </Tooltip>
          )}
          {(Profile?.profile?.role === "admin" ||
            Profile?.profile?.role === "coordinator") && (
              <MUIButton
                title="Add Job"
                startIcon={<AddIcon sx={{ marginRight: "-5px" }} />}
                component={Link}
                to="/jobpostadd"
                sx={{ backgroundColor: "#7F56D9", width: "110px" }}
              />
            )}
        </div>
      </Grid2>

      {/* Container 3 for Table */}
      <Grid2 item sx={{ marginTop: "15px" }}>
        <TabContext value={tabValue}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              mb: "15px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <TabList
                onChange={handleTabChange}
                aria-label="Overview and Candidates tabs"
                textColor="primary"
                indicatorColor="secondary"
              >
                <Tab
                  label="IT"
                  value="0"
                  className="tabs"
                  sx={{
                    textTransform: "none",
                    fontWeight: tabValue === "0" ? "bold" : "normal",
                    transition: "all 0.3s ease",
                  }}
                />
                <Tab
                  label="Non IT"
                  value="1"
                  className="tabs"
                  sx={{
                    textTransform: "none",
                    fontWeight: tabValue === "1" ? "bold" : "normal",
                    transition: "all 0.3s ease",
                  }}
                />
              </TabList>
            </Box>
            <Box sx={{ display: "flex", gap: 3, alignItems: "center", mr: 3 }}>
              {[
                {
                  label: "Junior",
                  gradient: "#078F04",
                },
                {
                  label: "Mid - Level",
                  gradient: "#629BF8",
                },
                {
                  label: "Senior",
                  gradient: "#E31010",
                },
                {
                  label: "CXO",
                  gradient: "#38C5DD",
                },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", alignItems: "center", gap: 1, border: "1px solid #E9EAEB", borderRadius: "4px", padding: "4px 10px", background: item.gradient, borderRadius: "20px" }}
                >
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: "#fff", // ✅ use gradient here
                    }}
                  />
                  <Typography variant="body2" sx={{ fontSize: "12px", fontWeight: 500, color: "#fff" }}>{item.label}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
          <Paper
            sx={{
              width: "100%",
              overflow: "auto",
              border: "1px solid #E9EAEB",
            }}
            elevation={0}
          >
            <Table>
              <TableHead
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                  width: "100%",
                }}
              >
                <TableRow>
                  <TableCell colSpan={100} sx={{ padding: "5px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        {showClearFilter &&
                          chips?.map(
                            (item, index) =>
                              item?.label && (
                                <Chip
                                  key={index}
                                  label={item?.label}
                                  size="small"
                                  variant="outlined"
                                  onDelete={item?.onDelete}
                                  className="Chip"
                                  deleteIcon={
                                    <CloseIcon
                                      sx={{ color: "#414651 !important" }}
                                    />
                                  }
                                />
                              )
                          )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "14px",
                        }}
                      >
                        <MUICancelButton
                          title="More Filters"
                          onClick={handleFilterDialogOpen}
                          startIcon={
                            <FilterListIcon
                              sx={{ fontSize: "20px !important" }}
                            />
                          }
                          sx={{
                            color: "#6941C6",
                            borderColor: "#D6BBFB",
                            fontWeight: 600,
                            width: "130px",
                          }}
                        />
                        {(keywords ||
                          positionId ||
                          selectedClient ||
                          selectedPositionType ||
                          selectedCoordinator ||
                          selectedStatus ||
                          selectedPriority ||
                          selectedlevelIds?.length > 0 ||
                          location) &&
                          showClearFilter && (
                            <MUICancelButton
                              title="Clear Filter"
                              sx={{ width: "100px" }}
                              onClick={handleMoreFiltersDelete}
                            />
                          )}
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tableHeadersCell">Name</TableCell>
                  <TableCell
                    className="tableHeadersCell"
                    sx={{ width: "100px" }}
                  >
                    Position Type/
                    <br />
                    Priority
                  </TableCell>
                  <TableCell
                    className="tableHeadersCell"
                    sx={{ textAlign: "center !important" }}
                  >
                    Fulfill Status
                  </TableCell>
                  {userRole === "recruiter" ? (
                    <></>
                  ) : (
                    <TableCell className="tableHeadersCell" align="left">
                      Job-Rewards
                    </TableCell>
                  )}
                  {userRole === "recruiter" ? (
                    externalRecruiter === "N" ? (
                      <></>
                    ) : (
                      <TableCell className="tableHeadersCell" align="left">
                        Can-Rewards
                      </TableCell>
                    )
                  ) : (
                    <TableCell className="tableHeadersCell" align="left">
                      Can-Rewards
                    </TableCell>
                  )}
                  <TableCell className="tableHeadersCell" align="left">
                    Referred By
                  </TableCell>
                  {/* <TableCell className="tableHeadersCell">Priority</TableCell> */}
                  <TableCell className="tableHeadersCell">Status</TableCell>
                  <TableCell className="tableHeadersCell" align="left">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              {!showTableLoader ? (
                jobPostingTableDatas?.length > 0 ? (
                  <TableBody>
                    {jobPostingTableDatas?.map((item, index) => {
                      const colors = [
                        "green",
                        "darkorange",
                        "purple",
                        "#3357FF",
                        "orangered",
                        "darkgreen",
                        "pink",
                      ];
                      const backgroundColor = colors[index % colors?.length];
                      return (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          <TableCell
                            className="tableBodyCell"
                          >
                            <Box sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              width: "100%",
                            }}>
                              <Box
                                sx={{
                                  width: 13,
                                  height: 13,
                                  borderRadius: "50%",
                                  background:
                                    item?.jobPositionLevel === "Senior"
                                      ? "#E31010"
                                      : item?.jobPositionLevel === "Mid - level"
                                        ? "#629BF8"
                                        : item?.jobPositionLevel === "Junior"
                                          ? "#078F04"
                                          : item?.jobPositionLevel === "CXO" &&
                                          "#38C5DD",
                                }}
                              />
                              <Box>
                                <span
                                  style={{
                                    color: "#53389E",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    whiteSpace: "nowrap",
                                  }}
                                  onClick={() => handleProfileSubmissionNav(item)}
                                >
                                  <Tooltip
                                    placement="top"
                                    title={item?.positionTitle}
                                    slotProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: "#0A0D12",
                                          borderRadius: "8px",
                                          padding: "8px 12px",
                                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                        },
                                      },
                                    }}
                                  >
                                    {truncateText(item.positionTitle, 30)}
                                  </Tooltip>
                                  {item?.isDuplicateJob === "Y" && (
                                    <Tooltip
                                      placement="top"
                                      title={`This job was duplicated from the parent job (ID: ${item?.parentJobId})`}
                                      slotProps={{
                                        tooltip: {
                                          sx: {
                                            backgroundColor: "#0A0D12",
                                            borderRadius: "8px",
                                            padding: "8px 12px",
                                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                          },
                                        },
                                      }}
                                    >
                                      <img
                                        src={Duplicate}
                                        alt="Duplicate Job"
                                        width={18}
                                        height={18}
                                        style={{
                                          marginLeft: "5px",
                                          cursor: "default",
                                          flexShrink: 0,
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                </span>
                                {""}
                                <br />
                                <span>{item?.positionId} </span>
                                {userRole === "recruiter" && externalRecruiter === "Y"
                                  ? item?.clientDisplayName === "N/A"
                                    ? "-"
                                    : item?.clientDisplayName
                                  : item?.clientName}
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell
                            className="tableBodyCell"
                            sx={{ width: "100px" }}
                          >
                            {" "}
                            {item.positionType}
                            <br />
                            <span
                              className={`priority-badge ${item?.priority?.toLowerCase()}`}
                            >
                              {" "}
                              {item.priority}{" "}
                            </span>{" "}
                          </TableCell>
                          <TableCell
                            className="tableBodyCell"
                            sx={{ textAlign: "center !important" }}
                          >
                            <Avatar
                              sx={{
                                bgcolor: "transparent",
                                fontWeight: "bold",
                                bgcolor: "#9C7BAF",
                                // background: 'linear-gradient(to bottom, rgb(126, 103, 123), rgb(180, 148, 164))',
                                // backgroundColor:'rgb(175, 60, 164)',
                                color: "white",
                                border: "1px solid white",
                                width: 40,
                                height: 40,
                                fontSize: "14px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {item?.totalJoinedCount +
                                "/" +
                                item?.noOfPosition}
                            </Avatar>
                          </TableCell>
                          {userRole === "recruiter" ? (
                            <></>
                          ) : (
                            <TableCell className="tableBodyCell">
                              {/* {
                                                            !item?.rewardType ? "-" : item?.rewardType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                        }<br></br> */}
                              {!item?.rewardType ? (
                                "-"
                              ) : item?.rewardType === "FC" ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  {item?.rewardAmount ? (
                                    <CurrencyRupeeIcon
                                      sx={{
                                        fontSize: "14px",
                                        color: "#a6aba5",
                                      }}
                                    />
                                  ) : (
                                    <span>-</span>
                                  )}
                                  <Typography sx={{ fontSize: "12.5px" }}>
                                    {item?.rewardAmount}
                                  </Typography>
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography sx={{ fontSize: "12.5px" }}>
                                    {item?.rewardPct}
                                    {item?.rewardPct ? "%" : "-"}
                                  </Typography>
                                </Box>
                              )}
                            </TableCell>
                          )}
                          {userRole === "recruiter" ? (
                            externalRecruiter === "N" ? (
                              <></>
                            ) : (
                              <TableCell className="tableBodyCell">
                                {/* {
                                                            !item?.candidateRewardType ? "-" : item?.candidateRewardType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                        }<br></br> */}
                                {!item?.candidateRewardType ? (
                                  "-"
                                ) : item?.candidateRewardType === "FC" ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    {item?.candidateRewardAmount ? (
                                      <CurrencyRupeeIcon
                                        sx={{
                                          fontSize: "14px",
                                          color: "#a6aba5",
                                        }}
                                      />
                                    ) : (
                                      <span>-</span>
                                    )}
                                    <Typography sx={{ fontSize: "12.5px" }}>
                                      {item?.candidateRewardAmount}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "12.5px" }}>
                                      {item?.candidateRewardPercentage}
                                      {item?.candidateRewardPercentage
                                        ? "%"
                                        : "-"}
                                    </Typography>
                                  </Box>
                                )}
                              </TableCell>
                            )
                          ) : (
                            <TableCell className="tableBodyCell">
                              {/* {
                                                            !item?.candidateRewardType ? "-" : item?.candidateRewardType === "FC" ? "Fixed Amount" : "Fixed Percentage"
                                                        }<br></br> */}
                              {!item?.candidateRewardType ? (
                                "-"
                              ) : item?.candidateRewardType === "FC" ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {item?.candidateRewardAmount ? (
                                      <>
                                        <CurrencyRupeeIcon
                                          sx={{
                                            fontSize: "14px",
                                            color: "#a6aba5",
                                          }}
                                        />
                                        <Typography sx={{ fontSize: "12.5px", lineHeight: 1 }}>
                                          {item?.candidateRewardAmount}
                                        </Typography>
                                      </>
                                    ) : (
                                      <span>-</span>
                                    )}
                                  </Box>


                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography sx={{ fontSize: "12.5px" }}>
                                    {item?.candidateRewardPercentage !== null
                                      ? `${item?.candidateRewardPercentage}%`
                                      : "-"}
                                  </Typography>
                                </Box>
                              )}
                            </TableCell>
                          )}
                          <TableCell className="tableBodyCell">
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "5px",
                                alignItems: "center",
                              }}
                            >
                              <Avatar
                                alt={item?.firstName || "NA"}
                                sx={{
                                  width: "32px",
                                  height: "32px",
                                  backgroundColor: backgroundColor,
                                  fontSize: "14px",
                                }}
                              >
                                {userRole === "recruiter"
                                  ? item?.isReferral === "Y"
                                    ? item?.positionCreatedUser === "You"
                                      ? item?.positionCreatedBy
                                        ?.charAt(0)
                                        ?.toUpperCase()
                                      : "?"
                                    : item?.positionCreatedBy
                                      ?.charAt(0)
                                      ?.toUpperCase()
                                  : item?.positionCreatedBy
                                    ?.charAt(0)
                                    ?.toUpperCase() || "?"}
                              </Avatar>
                              <Typography
                                className="tableBodyCells"
                                sx={{ color: "#181D27" }}
                              >
                                {userRole === "recruiter"
                                  ? item?.isReferral === "Y"
                                    ? item?.positionCreatedUser === "You"
                                      ? item?.positionCreatedBy
                                      : "******"
                                    : item?.positionCreatedBy
                                  : item?.positionCreatedBy}
                                <span
                                  style={{
                                    color: "#5417cd",
                                    fontWeight: 600,
                                    marginLeft: "4px",
                                  }}
                                >
                                  {userRole === "recruiter"
                                    ? item?.positionCreatedUser === "You"
                                      ? item?.isReferral === "Y"
                                        ? "(BA)"
                                        : ""
                                      : ""
                                    : item?.isReferral === "Y"
                                      ? "(BA)"
                                      : ""}
                                </span>
                                <br></br>
                                <span style={{ color: "#535862" }}>
                                  {userRole === "recruiter"
                                    ? item?.isReferral === "Y"
                                      ? item?.positionCreatedUser === "You"
                                        ? item?.positionCreatedEmailId
                                        : "***********"
                                      : item?.positionCreatedEmailId
                                    : item?.positionCreatedEmailId}
                                </span>
                              </Typography>
                            </Box>
                          </TableCell>
                          {/* <TableCell className='tableBodyCell'> <span className={`priority-badge ${item?.priority?.toLowerCase()}`}> {item.priority} </span> </TableCell> */}
                          <TableCell className="tableBodyCell">
                            {" "}
                            <span
                              className={`jobStatus-badge ${item?.positionStatus
                                ?.toLowerCase()
                                ?.replace(/\s+/g, "-")}`}
                            >
                              {" "}
                              {item.positionStatus}
                            </span>{" "}
                          </TableCell>
                          <TableCell
                            className="tableBodyCell"
                            sx={{ whiteSpace: "nowrap" }}
                            align="left"
                          >
                            {/* {(Profile?.profile?.role === 'admin' || Profile?.profile?.role === 'coordinator') && (
                                                        <Tooltip title={item.positionStatus === "Active" ? item.isReferral === "Y" ? item.rewardType ? item.candidateRewardType ? "Assign Recruiter" : "Candidate Reward is Missing" : item.candidateRewardType ? "Job Reward is Missing" : "Job Reward and Candidate Reward are Missing" : item.candidateRewardType ? "Assign Recruiter" : "Candidate Reward is Missing" : "Job status must be 'Active' before you can assign Recruiters"}
                                                            slotProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: "#0A0D12",
                                                                        borderRadius: '8px',
                                                                        padding: '8px 12px',
                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)'
                                                                    },
                                                                },
                                                            }}>
                                                            <div style={{ display: 'inline-block' }}>
                                                                <UsersIcon
                                                                    stroke={'#A4A7AE'}
                                                                    width={15}
                                                                    height={15}
                                                                    className="icons"
                                                                    style={{ cursor: item?.positionStatus === "Active" && item?.isReferral === "Y" ? item?.rewardType && item?.candidateRewardType ? 'pointer' : 'not-allowed' : item?.positionStatus === "Active" && item?.candidateRewardType ? "pointer" : "not-allowed" }}
                                                                    onClick={item?.isReferral === "Y" ? item?.positionStatus === "Active" && item?.rewardType && item?.candidateRewardType ? () => handleOpen(item) : null : item?.positionStatus === "Active" && item?.candidateRewardType ? () => handleOpen(item) : null}
                                                                />
                                                            </div>
                                                        </Tooltip>
                                                    )} */}
                            <Tooltip
                              title={
                                Profile?.profile?.role === "admin"
                                  ? item.positionStatus === "Active"
                                    ? item.isReferral === "Y"
                                      ? item.rewardType
                                        ? item.candidateRewardType
                                          ? "Assign Candidate"
                                          : "Candidate Reward is Missing"
                                        : "Job Reward and Candidate Reward are Missing"
                                      : item.candidateRewardType
                                        ? "Assign Candidate"
                                        : "Candidate Reward is Missing"
                                    : "Job status must be 'Active' before you can assign Candidates"
                                  : item.positionStatus === "Active"
                                    ? item.isReferral === "Y"
                                      ? item.candidateRewardType
                                        ? "Assign Candidate"
                                        : "You can't assign the candidate because the admin hasn't set the reward amount yet."
                                      : item.candidateRewardType
                                        ? "Assign Candidate"
                                        : "Candidate Reward is Missing"
                                    : "Job status must be 'Active' before you can assign Candidates"
                              }
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#0A0D12",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                    // cursor:Profile?.profile?.role === 'admin'?'pointer':'not-allowed'
                                  },
                                },
                              }}
                            >
                              <div style={{ display: "inline-block" }}>
                                <UserPlusIcon
                                  stroke={"#A4A7AE"}
                                  style={{
                                    cursor:
                                      Profile?.profile?.role === "admin"
                                        ? item.positionStatus !== "Active"
                                          ? "not-allowed"
                                          : item.isReferral === "Y"
                                            ? item.rewardType
                                              ? item.candidateRewardType
                                                ? "pointer"
                                                : "not-allowed"
                                              : "not-allowed"
                                            : item.candidateRewardType
                                              ? "pointer"
                                              : "not-allowed"
                                        : item.positionStatus === "Active"
                                          ? item.isReferral === "Y"
                                            ? item.candidateRewardType
                                              ? "pointer"
                                              : "not-allowed"
                                            : item.candidateRewardType
                                              ? "pointer"
                                              : "not-allowed"
                                          : "not-allowed",
                                  }}
                                  className="icons"
                                  onClick={
                                    Profile?.profile?.role === "admin"
                                      ? item.positionStatus === "Active"
                                        ? item.isReferral === "Y"
                                          ? item.rewardType
                                            ? item.candidateRewardType
                                              ? () => handleProfileNav(item)
                                              : null
                                            : null
                                          : item.candidateRewardType
                                            ? () => handleProfileNav(item)
                                            : null
                                        : null
                                      : item.positionStatus === "Active"
                                        ? item.isReferral === "Y"
                                          ? item.candidateRewardType
                                            ? () => handleProfileNav(item)
                                            : null
                                          : item.candidateRewardType
                                            ? () => handleProfileNav(item)
                                            : null
                                        : null
                                  }
                                />
                              </div>
                            </Tooltip>

                            <Tooltip
                              title="Manage Job Stage"
                              slotProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#0A0D12",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                  },
                                },
                              }}
                              onClick={() => handleManageEventsNav(item)}
                            >
                              <div style={{ display: "inline-block" }}>
                                <FileManageEventsIcon className="icons" />
                              </div>
                            </Tooltip>
                            {userRole !== "recruiter" ? (
                              <Tooltip
                                title="Duplicate"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#0A0D12",
                                      borderRadius: "8px",
                                      padding: "8px 12px",
                                      boxShadow:
                                        "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                    },
                                  },
                                }}
                              >
                                <div style={{ display: "inline-block" }}>
                                  <CopyIcon
                                    className="icons"
                                    style={{
                                      cursor: 'pointer'
                                      // item?.isReferral === "Y"
                                      // ? item?.rewardType &&
                                      //   item?.candidateRewardType
                                      //   ? "pointer"
                                      //   : "not-allowed"
                                      // : item?.positionStatus === "Active" &&
                                      //   item?.candidateRewardType
                                      //   ? "pointer"
                                      //   : "not-allowed",
                                    }}
                                    onClick={() => handleDuplicateDialogOpen(item)
                                      // item?.positionStatus === "Active" &&
                                      //   item?.isReferral === "Y"
                                      //   ? item?.rewardType &&
                                      //     item?.candidateRewardType
                                      //     ? () =>
                                      //       handleDuplicateDialogOpen(item)
                                      //     : null
                                      //   : item?.positionStatus === "Active" &&
                                      //     item?.candidateRewardType
                                      //     ? () => handleDuplicateDialogOpen(item)
                                      //     : null
                                    }
                                  />
                                </div>
                              </Tooltip>
                            ) : (
                              <></>
                            )}
                            {userRole !== "recruiter" ? (
                              <Tooltip
                                title="Edit Job"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#0A0D12",
                                      borderRadius: "8px",
                                      padding: "8px 12px",
                                      boxShadow:
                                        "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                    },
                                  },
                                }}
                              >
                                <div style={{ display: "inline-block" }}>
                                  <EditIcon
                                    stroke={"#A4A7AE"}
                                    className="icons"
                                    style={{
                                      cursor:
                                        Profile?.profile?.role === "recruiter"
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                    onClick={() => handleEditScreenNav(item)}
                                  />
                                </div>
                              </Tooltip>
                            ) : (
                              <></>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={8}>
                        <Typography className="emptydatas">
                          No Data Found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Box className="tableloader">
                      <TableLoader />
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                <TableRow>
                  <TableCell colSpan={100}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <MUICancelButton
                        title="Previous"
                        startIcon={
                          <ArrowBackIcon
                            sx={{ color: page === 1 ? "#a2a2a2" : "#414651" }}
                          />
                        }
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 1}
                        sx={{ height: "36px" }}
                      />

                      <Pagination
                        page={page}
                        onChange={handleChangePage}
                        count={Math.ceil(totalDataCount / rowsPerPage)}
                        siblingCount={1}
                        boundaryCount={1}
                        shape="rounded"
                        hidePrevButton
                        hideNextButton
                      />

                      <MUICancelButton
                        title="Next"
                        startIcon={
                          <ArrowForwardIcon
                            sx={{
                              color:
                                page === Math.ceil(totalDataCount / rowsPerPage)
                                  ? "#a2a2a2"
                                  : "#414651",
                            }}
                          />
                        }
                        onClick={() => handleChangePage(null, page + 1)}
                        disabled={
                          page === Math.ceil(totalDataCount / rowsPerPage)
                        }
                        sx={{ height: "36px" }}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </Paper>
        </TabContext>
        {/* <Table>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    className="tablepagination"
                                    count={totalDataCount || 0}
                                    onPageChange={handleChangePage}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    rowsPerPageOptions={[10, 20, 50]}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table> */}

        {/* Dialog to show more filters */}
        <Grid2 item>
          <Dialog
            open={filterDialogOpen}
            scroll="paper"
            maxWidth="md"
            className="sidePopup"
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              Filters
              <CloseIcon
                sx={{ color: "#717680", cursor: "pointer" }}
                onClick={handleFilterDialogClose}
              />
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Grid2
                  container
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  {/* Container 1 */}
                  <Grid2
                    item
                    container
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                    gap={2}
                  >
                    {/* <Grid2 item>
                                            <InputLabel className="input"> Keywords </InputLabel>
                                            <TextField
                                                className="textfields"
                                                size="small"
                                                placeholder="Enter the Keyword"
                                                value={keywords}
                                                onChange={handleKeywordChange}
                                            />
                                        </Grid2> */}

                    <Grid2 item>
                      <InputLabel className="input"> Position Id </InputLabel>
                      <TextField
                        className="textfields"
                        size="small"
                        placeholder="Enter Position Id"
                        value={positionId || ""}
                        onChange={handlePositionIdChange}
                      />
                    </Grid2>

                    {userRole !== "recruiter" && (
                      <Grid2 item sx={{ width: "100%" }}>
                        <InputLabel className="inputlabels">
                          Client Names
                        </InputLabel>
                        <Select
                          className="dropdown"
                          displayEmpty
                          value={selectedClient || ""}
                          onChange={(e) =>
                            handleClientDropdownChange(e.target.value)
                          }
                          IconComponent={KeyboardArrowDownIcon}
                          open={openClientName}
                          onOpen={() => setOpenClientName(true)}
                          onClose={() => setOpenClientName(false)}
                          renderValue={(selected) => {
                            if (!selected || selected === "") {
                              return (
                                <p className="menuItemsPlaceholder">
                                  Select By Client
                                </p>
                              );
                            }
                            try {
                              const selectedItem = clientDropdownDatas?.find(
                                (client) =>
                                  client?.clientId?.toString() ===
                                  selected.toString()
                              );
                              return selectedItem?.clientName || "";
                            } catch (error) {
                              console.error(
                                "Error rendering selected value:",
                                error
                              );
                              return "";
                            }
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <TextField
                              type="text"
                              placeholder="Search Client..."
                              variant="outlined"
                              className="textfields"
                              size="small"
                              fullWidth
                              onWheel={(e) => e.stopPropagation()}
                              onKeyDown={(e) => e.stopPropagation()}
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                              value={searchClient}
                              onChange={handleSearchClient}
                              sx={{
                                "& input": {
                                  fontSize: "14px",
                                  padding: "6px 8px",
                                },
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "px",
                                },
                                marginLeft: '20px',
                                width: '90% !important'
                              }}
                            />
                            <Tooltip title={"Close"} arrow>
                              <IconButton
                                size="small"
                              >
                                <ClearIcon
                                  sx={{ fontSize: "18px", color: "#a2a2a2" }}
                                  onClick={() => {
                                    setOpenClientName(false);
                                    setSearchClient("")
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                          {(searchClient ? filterClient : clientDropdownDatas)?.length > 0 ? (
                            (searchClient ? filterClient : clientDropdownDatas)?.map((item) => (
                              <MenuItem
                                key={item?.clientId}
                                value={item?.clientId}
                                className="menuitems"
                              >
                                {item?.clientName}
                                {item?.clientId === +selectedClient && (
                                  <DoneIcon className="doneIcon" />
                                )}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled sx={{ justifyContent: "center" }}>
                              <Typography variant="body2" color="text.secondary">
                                No data found
                              </Typography>
                            </MenuItem>
                          )}
                        </Select>
                      </Grid2>
                    )}
                    <Grid2 item>
                      <InputLabel className="input">Position Levels</InputLabel>
                      <Select
                        multiple
                        className="dropdown"
                        displayEmpty
                        value={selectedlevelIds || []} // must store IDs
                        onChange={
                          (e) => {
                            const ids = e.target.value;
                            const names = positionLevelDropDown?.response
                              ?.filter((opt) =>
                                ids.includes(opt.jobPositionLevelId)
                              )
                              ?.map((opt) => opt.jobPositionLevelName);

                            setSelectedLevelNames(names);
                            setSelectedlevelIds(ids);
                            localStorage.setItem(
                              "isLevelIds",
                              JSON.stringify(ids)
                            );
                          } // update state
                        }
                        IconComponent={KeyboardArrowDownIcon}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return (
                              <p className="menuItemsPlaceholder">
                                Select By Position Type
                              </p>
                            );
                          }

                          // Show names instead of IDs in dropdown
                          const selectedNames = positionLevelDropDown?.response
                            ?.filter((opt) =>
                              selected.includes(opt.jobPositionLevelId)
                            )
                            ?.map((opt) => opt.jobPositionLevelName);

                          return selectedNames.join(", ");
                        }}
                      >
                        <MenuItem value="" disabled>
                          <span className="menuItemsPlaceholder">
                            Select By Position Levels
                          </span>
                        </MenuItem>

                        {positionLevelDropDown?.response?.map((option) => (
                          <MenuItem
                            key={option?.jobPositionLevelId}
                            value={option?.jobPositionLevelId} // ✅ Use ID as value
                          >
                            <Checkbox
                              checked={selectedlevelIds.includes(
                                option?.jobPositionLevelId
                              )} // ✅ Check based on ID
                            />
                            <ListItemText
                              primary={option?.jobPositionLevelName}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid2>

                    <Grid2 item>
                      <InputLabel className="input"> Position Type </InputLabel>
                      <Select
                        className="dropdown"
                        displayEmpty
                        value={selectedPositionType || ""}
                        onChange={handlePositionTypeChange}
                        IconComponent={KeyboardArrowDownIcon}
                        open={openPosition}
                        onOpen={() => setOpenPosition(true)}
                        onClose={() => setOpenPosition(false)}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <p className="menuItemsPlaceholder">
                                Select By Position Type
                              </p>
                            );
                          } else {
                            const selectedItem = positionTypeOptions?.find(
                              (name) => name?.label === selected
                            );
                            return selectedItem ? selectedItem?.label : "";
                          }
                        }}
                      >
                        <Box className="selectClearButton">
                          <MenuItem value="" disabled>
                            {" "}
                            <span className="menuItemsPlaceholder">
                              {" "}
                              Select By Position Type{" "}
                            </span>
                          </MenuItem>
                          <Tooltip title={"Close"} arrow>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setOpenPosition(false);
                              }}
                            >
                              <ClearIcon
                                sx={{ fontSize: "18px", color: "#a2a2a2" }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                        {positionTypeOptions?.map((option) => (
                          <MenuItem
                            key={option?.id}
                            value={option?.label}
                            className="menuitems"
                          >
                            {option?.label}
                            {option?.label === selectedPositionType && (
                              <DoneIcon className="doneIcon" />
                            )}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid2>
                  </Grid2>

                  {/* container 2 */}
                  <Grid2
                    item
                    container
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      marginTop: "15px",
                    }}
                    gap={2}
                  >
                    {/* {
                                            userRole === "admin" && (
                                                <Grid2 item sx={{ width: '100%' }}>
                                                    <InputLabel className="input"> Co-ordinator </InputLabel>
                                                    <Dropdown
                                                        className="dropdown"
                                                        placeholder="Select Co-ordinator"
                                                        value={selectedCoordinator || ""}
                                                        options={coordinatorDropdownDatas || []}
                                                        onChange={(value) => handleCoordinatorchange(value)}
                                                        valueKey="coordinatorId"
                                                        labelKey="label"
                                                    />
                                                </Grid2>
                                            )
                                        } */}

                    <Grid2 item>
                      <InputLabel className="input"> Status </InputLabel>
                      <Select
                        className="dropdown"
                        displayEmpty
                        value={selectedStatus || ""}
                        onChange={handleStatusChange}
                        IconComponent={KeyboardArrowDownIcon}
                        open={openByStatus}
                        onOpen={() => setOpenByStatus(true)}
                        onClose={() => setOpenByStatus(false)}
                        renderValue={(selected) =>
                          !selected ? (
                            <p className="menuItemsPlaceholder">
                              Select By Status
                            </p>
                          ) : (
                            statusOptions?.find(
                              (name) => name?.label === selected
                            )?.label || ""
                          )
                        }
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <MenuItem value="" disabled>
                            {" "}
                            <span className="menuItemsPlaceholder">
                              {" "}
                              Select By Status{" "}
                            </span>
                          </MenuItem>
                          <Tooltip title={"Close"} arrow>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setOpenByStatus(false);
                              }}
                            >
                              <ClearIcon
                                sx={{ fontSize: "18px", color: "#a2a2a2" }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                        {statusOptions?.map((option) => (
                          <MenuItem
                            className="menuitems"
                            key={option?.id}
                            value={option?.label}
                          >
                            {option?.label}
                            {option?.label === selectedStatus && (
                              <DoneIcon className="doneIcon" />
                            )}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid2>

                    <Grid2 item>
                      <InputLabel className="input"> Priority </InputLabel>
                      <Select
                        className="dropdown"
                        displayEmpty
                        value={selectedPriority || ""}
                        onChange={handlePriorityChange}
                        IconComponent={KeyboardArrowDownIcon}
                        open={openByPriority}
                        onOpen={() => setOpenByPriority(true)}
                        onClose={() => setOpenByPriority(false)}
                        sx={{ borderRadius: "10px" }}
                        renderValue={(selected) =>
                          !selected ? (
                            <span className="menuItemsPlaceholder">
                              {" "}
                              Select By Priority
                            </span>
                          ) : (
                            priorityOptions?.find(
                              (opt) => opt?.label === selected
                            )?.label || ""
                          )
                        }
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <MenuItem value="" disabled>
                            {" "}
                            <span className="menuItemsPlaceholder">
                              {" "}
                              Select By Priority{" "}
                            </span>
                          </MenuItem>
                          <Tooltip title={"Close"} arrow>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setOpenByPriority(false);
                              }}
                            >
                              <ClearIcon
                                sx={{ fontSize: "18px", color: "#a2a2a2" }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                        {priorityOptions?.map((option) => {
                          return (
                            <MenuItem
                              className="menuitems"
                              key={option?.id}
                              value={option?.label}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                margin: "5px",
                              }}
                            >
                              {option?.label}
                              {option?.label === selectedPriority && (
                                <DoneIcon
                                  sx={{ fontSize: "18px", color: "#7F56D9" }}
                                />
                              )}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </Grid2>

                    {/* <Grid2 item>
                                            <InputLabel className="input"> Location </InputLabel>
                                            <TextField
                                                className="textfields"
                                                size="small"
                                                placeholder="Enter Location"
                                                value={location}
                                                onChange={handleLocationChange}
                                            />
                                        </Grid2> */}
                  </Grid2>
                </Grid2>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Grid2
                item
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <MUICancelButton
                  title="Cancel"
                  onClick={handleFilterDialogClose}
                  sx={{ width: "42%" }}
                />
                <MUIButton
                  sx={{ width: "42%" }}
                  title="Apply"
                  onClick={() => {
                    setPage(1);
                    setShouldFetch(true);
                  }}
                />
              </Grid2>
            </DialogActions>
          </Dialog>
        </Grid2>

        {/* Dialog to show Duplicate */}
        <Grid2 item>
          <Dialog
            open={duplicateDialogOpen}
            onClose={handleDuplicateDialogClose}
            scroll="paper"
            maxWidth="xs"
            sx={{
              "& .MuiDialog-paper": {
                width: "90%",
                maxWidth: "500px",
                height: "auto",
                borderRadius: "15px",
                padding: "3px",
              },
            }}
          >
            <DialogContent>
              <DialogContentText>
                <div style={{ display: "flex", gap: "12px", marginTop: "9px" }}>
                  <div
                    style={{
                      backgroundColor: "#E6E6FA",
                      borderRadius: "40px",
                      height: "40px",
                      width: "45px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ContentCopyOutlinedIcon sx={{ color: "#7F56D9" }} />
                  </div>
                  <div>
                    <Typography
                      sx={{
                        color: "#181D27",
                        fontWeight: 600,
                        fontSize: "17px",
                      }}
                    >
                      Duplicate Row?
                    </Typography>
                    <Typography
                      sx={{
                        color: "#535862",
                        fontWeight: 400,
                        fontSize: "14px",
                      }}
                    >
                      Are you sure you want to Duplicate this row?
                    </Typography>
                  </div>
                </div>
              </DialogContentText>
              <Grid2
                item
                sx={{
                  marginTop: "25px",
                  display: "flex",
                  gap: "10px",
                  justifyContent: "flex-end",
                }}
              >
                <MUICancelButton
                  title="No"
                  onClick={handleDuplicateDialogClose}
                />
                <MUIButton
                  title="Yes"
                  onClick={handleDuplicate}
                  sx={{ backgroundColor: "#7F56D9", borderRadius: "10px" }}
                />
              </Grid2>
            </DialogContent>
          </Dialog>
        </Grid2>

        {/* Dialog to show recruiters */}
        <Grid2 item>
          <Dialog
            open={open}
            onClose={handleClose}
            scroll="paper"
            maxWidth="md"
            className="sidePopup"
          >
            <DialogContent>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        color: "#000000",
                        fontWeight: 600,
                        fontSize: "14px",
                      }}
                    >
                      Recruiters
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        color: "#6941C6",
                        fontWeight: 600,
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {rowDatas?.positionTitle} | {rowDatas?.clientName}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                    gap: "5px",
                    marginTop: "5px",
                  }}
                >
                  <Box>
                    <Typography
                      onClick={() => handleChange("2")}
                      sx={{
                        fontSize: "14px",
                        fontWeight: value === "2" ? 600 : 300,
                        color: value === "2" ? "#6941C6" : "#000000",
                        cursor: "pointer",
                        transform: value === "2" ? "scale(1.1)" : "scale(0.8)",
                        textShadow:
                          value === "2"
                            ? "0px 2px 4px rgba(0, 0, 0, 0.3)"
                            : "none",
                        transition:
                          "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out, color 0.3s ease-in-out",
                        transformOrigin: "center",
                      }}
                    >
                      Assign Recruiters
                    </Typography>
                  </Box>

                  <Box sx={{ borderRight: "1px solid black" }}></Box>

                  <Box>
                    <Typography
                      onClick={() => handleChange("1")}
                      sx={{
                        fontSize: "14px",
                        fontWeight: value === "1" ? 600 : 300,
                        color: value === "1" ? "#6941C6" : "#000000",
                        cursor: "pointer",
                        transform: value === "1" ? "scale(1.1)" : "scale(0.8)",
                        textShadow:
                          value === "1"
                            ? "0px 2px 4px rgba(0, 0, 0, 0.3)"
                            : "none",
                        transition:
                          "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out, color 0.3s ease-in-out",
                        transformOrigin: "center",
                      }}
                    >
                      Assigned Recruiters
                    </Typography>
                  </Box>
                </Box>

                <TextField
                  size="small"
                  placeholder="Search"
                  className="textfields"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <SearchIconLg style={{ paddingRight: "5px" }} />
                      ),
                    },
                  }}
                  value={searchRecruiter}
                  onChange={handleSearchRecruiterChange}
                  sx={{
                    marginTop: "15px",
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#9E77ED",
                      },
                    },
                  }}
                />

                {!recruiterListLoader ? (
                  filteredRecruiterLists?.length > 0 ? (
                    filteredRecruiterLists?.map((item, index) => {
                      const firstLetter = item?.recruiterName;
                      const letter = firstLetter?.charAt(0)?.toUpperCase();
                      // const firstLetter = item?.isExternalRecruiter === "Y" ? "E" : "I"
                      // const letter = firstLetter
                      const colors = [
                        "green",
                        "darkorange",
                        "purple",
                        "#3357FF",
                        "orangered",
                        "darkgreen",
                        "pink",
                      ];
                      const backgroundColor = colors[index % colors?.length];
                      return (
                        <DialogContentText
                          sx={{
                            width: "100%",
                            fontSize: "13.5px",
                            color: "#000000",
                            alignItems: "center",
                            display: "flex",
                          }}
                        >
                          <Grid2
                            container
                            sx={{ width: "100%", marginTop: "15px" }}
                          >
                            <Card
                              className="recruitercard"
                              elevation={0}
                              key={item?.recruiterId}
                              onClick={() =>
                                handleAssignRecruiterCheckbox(item?.recruiterId)
                              }
                              sx={{
                                border:
                                  value === "1"
                                    ? !recruiterCheckbox?.includes(
                                      item?.recruiterId
                                    ) && "1px solid #9E77ED"
                                    : value === "2"
                                      ? recruiterCheckbox?.includes(
                                        item?.recruiterId
                                      ) && "1px solid #9E77ED"
                                      : "",
                                "& .MuiCardContent-root": {
                                  padding: "12px",
                                },
                              }}
                            >
                              <CardContent>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Box sx={{ display: "flex", gap: "10px" }}>
                                    <Avatar
                                      sx={{ backgroundColor: backgroundColor }}
                                    >
                                      {letter}
                                    </Avatar>
                                    <div>
                                      <Typography
                                        sx={{
                                          color: "#181D27",
                                          fontSize: "14px",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {item?.recruiterName}{" "}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          color: "#717680",
                                          fontSize: "10px",
                                        }}
                                      >
                                        {item?.recruiterCompanyName}
                                      </Typography>
                                    </div>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        color: "#717680",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {item?.isExternalRecruiter === "N"
                                        ? "Internal Recruiter"
                                        : "Business Associate"}
                                    </Typography>
                                  </Box>
                                </div>
                                <Grid2
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    marginTop: "10px",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <Grid2
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <EmailOutlinedIcon className="icons" />
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: "#6941C6",
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        alignItems: "center",
                                        display: "flex",
                                      }}
                                    >
                                      {item?.recruiterEmailId}{" "}
                                      <ArrowOutwardIcon
                                        sx={{ fontSize: "16px" }}
                                      />{" "}
                                    </Typography>
                                  </Grid2>

                                  <Grid2
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <LocalPhoneOutlinedIcon className="icons" />
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: "#6941C6",
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        alignItems: "center",
                                        display: "flex",
                                      }}
                                    >
                                      {item?.recruiterPhone}
                                      <ArrowOutwardIcon
                                        sx={{ fontSize: "16px" }}
                                      />{" "}
                                    </Typography>
                                  </Grid2>
                                </Grid2>
                              </CardContent>
                            </Card>
                          </Grid2>
                        </DialogContentText>
                      );
                    })
                  ) : (
                    <DialogContentText
                      sx={{ width: "100%", marginTop: "10px" }}
                    >
                      <Typography className="emptydatas">
                        No Data Found
                      </Typography>
                    </DialogContentText>
                  )
                ) : (
                  <Box className="tableloader">
                    <TableLoader />
                  </Box>
                )}
              </div>
            </DialogContent>
            <DialogActions>
              <Grid2
                item
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <MUICancelButton
                  title="Cancel"
                  onClick={handleClose}
                  sx={{ width: "42%" }}
                />
                <MUIButton
                  disabled={isAssign?.length === 0}
                  title={value === "1" ? "Unassign" : "Assign"}
                  onClick={handleAssignRecruiter}
                  sx={{ width: "42%" }}
                />
              </Grid2>
            </DialogActions>
          </Dialog>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default JobPosting;
